import React, { useState, useEffect } from "react";
import shopify from "@arctheme-components/../../../js/shopify"
import {Paragraph} from '../../../elements/Paragraph/Paragraph';
import { mobileBreakpoint } from "../../../../../entrypoints/theme";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import "./CartSummary.scss";

export const CartSummary = ({ settings }) => {
  const { section, routes, blocks } = settings;
  const [cart, setCart] = useState(settings.cart);
  const [products, setProducts] = useState([]);
  const isMobile = useMobileBreakpoint(mobileBreakpoint);

  useEffect(() => {
    const productIdsList = [...new Set(cart.items.map((product) => product.product_id))];

    async function fetchProducts(productIds) {
      const products = await shopify.getShopifyProductList(productIds);
      setProducts(products);
    }

    fetchProducts(productIdsList);
    document.addEventListener("liquid-ajax-cart:request-end", function (event: any) {
      const { requestState, cart, previousCart, sections } = event.detail;
      setCart(cart);
    });

    return () => {
      window.removeEventListener("liquid-ajax-cart:request-end", () => {});
    };
  }, []);

  let sectionHeadingClass = "h4";
  let pricesClass = "h4";
  let shippingInfoClass = "b2";

    if (isMobile) {
      sectionHeadingClass = "h5";
      pricesClass = "h4";
      shippingInfoClass = "b2";
    }

  const paymentBlock = blocks.length ? blocks.find((block) => block.type === "payment_icons") : null;
  const cart_subtotal = cart.original_total_price;

  const totalSavings = cart.items.reduce((acc, item) => {
    if (item.selling_plan_allocation) {
      const originalPrice = item.selling_plan_allocation.compare_at_price;
      const discountedPrice = item.selling_plan_allocation.price;
      const itemSavings = ((originalPrice - discountedPrice) / 100) * item.quantity;
      return acc + itemSavings;
    } else if (item.line_level_discount_allocations) {
      let itemDiscount = 0;
      item.line_level_discount_allocations.forEach((discount) => {
        itemDiscount += discount.amount;
      });
      const itemSavings = itemDiscount / 100;
      return acc + itemSavings;
    } else {
      const product: any = products.find((product: any) => product.id === item.product_id);
      const originalPrice = product?.compare_at_price;
      if (originalPrice) {
        const discountedPrice = item.price;
        const itemSavings = ((originalPrice - discountedPrice) / 100) * item.quantity;
        return acc + itemSavings;
      }
    }
    return acc;
  }, 0);

  const cartSubtotal = cart_subtotal / 100;
  const totalBeforeSavings = totalSavings + cartSubtotal;
  const [currencySymbol, setCurrencySymbol] = useState('');

  useEffect(() => {
    window.addEventListener('currency_initialised' , (event) => {
      setCurrencySymbol(event.detail.currency.symbol);
    });
  }, []);


  return (
      <div className="cart__summary">
        <div className="cart__summary-top"></div>
        <form
            id="cart"
            action={routes.cart_url}
            method="post"
            className="cart__summary-form"
        >
          <div className="cart__summary-items">
            {section.show_subtotal && (
              <div className={`cart__summary-items-item ${pricesClass}`}>
                <span>Subtotal</span>
                <span>{currencySymbol} {cartSubtotal.toFixed(0)}</span>
              </div>
            )}
            {section.show_savings && totalSavings > 0 && (
                <div className={`cart__summary-items-item savings-pill ${pricesClass}`}>
                  <span>Total Savings</span>
                  <span>-{currencySymbol} {totalSavings.toFixed(0)}</span>
                </div>
            )}
            {section.show_shipping_info && section.shipping_info_location === 'in_totals' && (
              <div className={`cart__summary-items-item ${shippingInfoClass}`}>
                <span>Shipping</span>
                <div className="shipping-details">
                  <div>Calculated at checkout</div>
                  <div>Free for orders over $99</div>
                </div>
              </div>
            )}
            <div className={`cart__summary-items-item ${pricesClass}`}>
              <span>Total</span>
              <span>{currencySymbol} {(cart.items_subtotal_price / 100).toFixed(0)}</span>
            </div>
          </div>
          {section.show_cart_note && (
              <div className="cart_notes">
                <label htmlFor="cart_note">Cart Notes</label>
                <input
                    className="cart_notes-input"
                    type="text"
                    name="cart_note"
                    id="cart_note"
                    placeholder="Enter notes for cart"
                />
              </div>
          )}
          <button className="button button-primary" type="submit" name="checkout" form="checkout">
            Checkout
          </button>
          {section.show_shipping_info && section.shipping_info_location === 'below_button' && (
              <div className={`cart__summary-shipping ${shippingInfoClass}`}>
                <p>Discount codes and credit vouchers can be applied at checkout.</p>
              </div>
            )}
          {paymentBlock?.settings.payment_icons && (
              <div className="payment-icons">
                <img
                    src={paymentBlock.settings.payment_icons}
                    alt="Payment icons"
                    className="mx-auto"
                />
              </div>
          )}
        </form>
        <div className="info-area">
          <div className="help-section">
            <h4 className={`help-section-title ${sectionHeadingClass}`}>
              {section.cart_information_1_title}
            </h4>
            <Paragraph
              type='b2'
              text={`${section.cart_information_1_description}`}
            />
          </div>
          <div className="shipping-section">
          <h4 className={`shipping-section-title ${sectionHeadingClass}`}>
              {section.cart_information_2_title}
            </h4>
            <Paragraph
              type='b2'
              text={`${section.cart_information_2_description}`}
            />
          </div>
        </div>
      </div>
  );
};
